import { render, staticRenderFns } from "./XkzHchxTj.vue?vue&type=template&id=d4ed984a&scoped=true&"
import script from "./XkzHchxTj.vue?vue&type=script&lang=js&"
export * from "./XkzHchxTj.vue?vue&type=script&lang=js&"
import style0 from "./XkzHchxTj.vue?vue&type=style&index=0&id=d4ed984a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ed984a",
  null
  
)

export default component.exports